import { render, staticRenderFns } from "./DisplayComponent.vue?vue&type=template&id=3ca9e63f"
import script from "./DisplayComponent.vue?vue&type=script&lang=js"
export * from "./DisplayComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports